import React, { Component } from "react";
import { Layout, Menu } from "antd";
const { Sider, Content } = Layout;
import Toolbar from "./toolbar";

import { withRouter } from "react-router";
import { omitBy, isEmpty } from "lodash";
import { keepOnlyReexamQueryStrings, mapReexamQueryStringToName } from "../../helpers/url";
import { withUser } from "@unifiedpatents/sso";
import AppliedFilters from "../common/applied-filters";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  verticalGutter: {
    marginTop: 16
  }
};

class ExParteSearch extends Component {
  state = {};

  componentDidMount() {}

  render() {
    const {
      status: { isLoggedIn, canAccessData },
      metadata
    } = this.props.user;
    const accessLevel = canAccessData && metadata.authorization.roles.indexOf("disallow-case-export") < 0 ? "full" : isLoggedIn ? "guest" : "public";
    const filter = this._getFilter();
    return (
      <div style={styles.body}>
        <Layout>
          <Sider width={260} breakpoint="lg" collapsedWidth="0" style={{ background: "transparent", marginRight: 16 }}>
            <Toolbar filter={filter} accessLevel={accessLevel} />
          </Sider>
          <Content>
            <AppliedFilters fieldSelector={keepOnlyReexamQueryStrings} fieldMapper={mapReexamQueryStringToName} />
            <Menu selectedKeys={[this.props.location.pathname]} onClick={this._onMenuClick} mode="horizontal">
              <Menu.Item key="/exparte/search">{"APPLICATION LIST"}</Menu.Item>
              <Menu.Item key="/exparte/analytics">{"ANALYTICS"}</Menu.Item>
            </Menu>
            {React.cloneElement(this.props.children, {
              key: this.props.location.pathname + this.props.location.search,
              filter,
              accessLevel
            })}
          </Content>
        </Layout>
      </div>
    );
  }

  _getFilter = () => {
    const query = keepOnlyReexamQueryStrings(this.props.location.query);
    return {
      ...omitBy(
        {
          application_number: query.application_number,
          filing_date: query.filing_date,
          application_status: query.application_status,
          application_status_date: query.status_date,
          examiner_art_unit: query.art_unit,
          national_class: query.national_class,
          national_subclass: query.national_subclass,
          patent_number: query.patent_number,
          examiner_name: query.examiner,
          law_firm: query.law_firm,
          owner: query.owner,
          requester: query.requester,
          exparte_status: query.exparte_status
        },
        isEmpty
      )
    };
  };

  _onMenuClick = item => {
    this.props.router.push({
      pathname: item.key,
      query: keepOnlyReexamQueryStrings(this.props.location.query)
    });
  };
}

export default withUser(withRouter(ExParteSearch));
